
export const TIPOLOGIA_CONTRATTO = {
  INDETRMINATO: 1,
  DETERMINATO: 2,
};
